import React from "react";
import {AwaitingSign} from "./awaitingSign";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const AwaitingSignPage = () => <ConsentDocumentsLayout><AwaitingSign/></ConsentDocumentsLayout>;
